import React from 'react';
import { Glyphicon, Modal, Button } from 'react-bootstrap';
import Comparison from './comparison';

class ComparisonRoot extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            hasBusinessRules: false,
            objectData: null
        };

        this.getObjectData = this.getObjectData.bind(this);
        this.onShow = this.onShow.bind(this);
        this.onHide = this.onHide.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    checkForBusinessRules = (objectData) => {
        if (objectData) {
            const comparisons = manywho.utils.getObjectDataProperty(objectData.properties, 'Comparisons');
            const rules = manywho.utils.getObjectDataProperty(objectData.properties, 'Rules');

            if ((comparisons.objectData && comparisons.objectData.length > 0) || (rules.objectData && rules.objectData.length > 0))
                return true;
        }

        return false;
    }

    getObjectData() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        if (model.isVisible === true) {
            const state = manywho.state.getComponent(this.props.id, this.props.flowKey) || {};

            let objectData = state.objectData.length > 0 ? state.objectData[0] : model.objectData[0];
            if (objectData)
                objectData = JSON.parse(JSON.stringify(objectData));

            const hasBusinessRules = this.checkForBusinessRules(objectData);

            this.setState({ objectData, hasBusinessRules });

            return objectData;
        }

        return null;
    }

    onShow(e) {
        this.getObjectData();
        this.setState({ isVisible: true });
    }

    onHide(e) {
        const hasBusinessRules = this.checkForBusinessRules(this.state.objectData);
        this.setState({ isVisible: false, objectData: null, hasBusinessRules });
    }

    onSave(e) {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);
        manywho.state.setComponent(this.props.id, { objectData: [this.state.objectData] }, this.props.flowKey, true);
        manywho.component.handleEvent(this, model, this.props.flowKey);
        this.onHide(e);
    }

    onChange(objectData) {
        this.setState({ objectData: objectData });
    }

    componentDidMount() {
        const objectData = this.getObjectData();
        const hasBusinessRules = this.checkForBusinessRules(objectData);
        this.setState({ hasBusinessRules });
    }

    componentWillReceiveProps(nextProps) {
        const state = manywho.state.getComponent(this.props.id, this.props.flowKey) || {};

        if (this.state.objectData === null
            || this.state.objectData && (!state.objectData || state.objectData.length === 0)) {
            const objectData = this.getObjectData();
            manywho.state.setComponent(this.props.id, { objectData: [objectData] }, this.props.flowKey);
            const hasBusinessRules = this.checkForBusinessRules(objectData);
            this.setState({ hasBusinessRules });
        }
    }

    render() {
        const model = manywho.model.getComponent(this.props.id, this.props.flowKey);

        if (model.isVisible === false)
            return null;

        const objectDataRequest = {
            stateId: manywho.utils.extractStateId(this.props.flowKey),
            typeElementBindingId: "ecf9e2b7-1d3a-4ca7-8d8c-53dad545a329",
            objectDataType: {
                "typeElementId": "0cae1572-df7a-481e-ac73-74dd08b72b92",
                "developerName": "ValueElementIdReference",
                "properties": [{
                    "developerName": "DeveloperName",
                    "list": null
                }, {
                    "developerName": "TypeElementDeveloperName",
                    "list": null
                }, {
                    "developerName": "TypeElementPropertyDeveloperName",
                    "list": null
                }, {
                    "developerName": "TypeElementPropertyTypeElementId",
                    "list": null
                },{
                    "developerName": "TypeElementId",
                    "list": null
                }, {
                    "developerName": "ContentType",
                    "list": null
                }, {
                    "developerName": "IsFixed",
                    "list": null
                }, {
                    "developerName": "Access",
                    "list": null
                }, {
                    "developerName": "Id",
                    "list": null
                }, {
                    "developerName": "TypeElementPropertyId",
                    "list": null
                }]
            }
        }

        const flowId = (model.tags || []).find(tag => manywho.utils.isEqual(tag.developerName, 'FlowId', true));
        const container = document.querySelector('.flow-editor.active') || document.querySelector('.page-editor.active') || document.querySelector('.admin');

        let glyph = 'plus';
        let label = 'Create Business Rules';

        if (this.state.hasBusinessRules) {
            glyph = 'pencil';
            label = 'Edit Business Rules';
        }

        return <div>
            <Button className="edit-business-rules" bsStyle="primary" onClick={this.onShow}><Glyphicon glyph={glyph}/>{label}</Button>
            <Modal dialogClassName="comparison-root-dialog" container={container} show={this.state.isVisible} onHide={this.onHide} backdrop={true} bsSize="large">
                <Modal.Header>
                    <Modal.Title>Business Rules</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="comparisons">
                        {this.state.isVisible ? <Comparison objectData={this.state.objectData} objectDataRequest={objectDataRequest} onChange={this.onChange} isRoot={true} flowId={flowId ? flowId.contentValue : null} /> : null}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="btn-outline" onClick={this.onHide}>Cancel</Button>
                    <Button bsStyle="primary" onClick={this.onSave}>Save</Button>
                </Modal.Footer>
            </Modal>
        </div>
    }
}

export default ComparisonRoot;
